<template>
  <esg-base-chart height="270px">
    <loading :active="loading"
             :z-index="1000"
             :is-full-page="false"/>
    <apex-chart type="donut"
                :width=this.width
                :height=this.height
                ref="chart"
                v-show="!loading"
                :series="series"
                :options="chartOptions"/>
  </esg-base-chart>
</template>
<script>
import EsgBaseChart from "@/components/esg/base/EsgBaseChart.vue";

export default {
  components: { EsgBaseChart },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '270'
    },
    corporation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      series: [],
      chartOptions: {
        chart: {
          fontFamily: 'NanumGothic, serif',
          events: {
            dataPointSelection: () => this.$emit('dataPointSelection', this.corporation),
            dataPointMouseEnter: (event) => event.target.style.cursor = 'pointer'
          }
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              size: '70%',
              labels: { // Number at the center
                show: true,
                value: {
                  show: true,
                  fontSize: '14px',
                  formatter: val => this.formatNumber(val, 0) + ' tCO2e'
                },
                total: {
                  show: true,
                  label: '총 배출량',
                  color: 'black',
                  fontSize: '14px',
                  formatter: chart => {
                    const total = chart.config.series.reduce((a, b) => a + b, 0)
                    return this.formatNumber(total, 0) + ' tCO2e'
                  }
                },
              },
            },
          },
        },
        dataLabels: { // Number on each slice
          enabled: false
        },
        tooltip: {
          show: true,
          y: {
            formatter: val => this.formatNumber(val, 2) + ' tCO2e'
          },
        },
        legend: {
          position: 'bottom',
        },
        title: {
          text: this.corporation.name,
          align: "center",
          style: {
            fontSize: '14px',
            fontWeight: 'bold',
          },
        },
        states: {
          hover: { filter: { type: 'none', } },
          active: { filter: { type: 'none', } },
        },
      },
    }
  },
  created() {
    this.fetchData()
  },
  beforeDestroy() {
    if (this.abortController) {
      this.abortController.abort();
    }
  },
  methods: {
    async fetchData() {
      try {
        this.loading = true;

        let year = new Date().getFullYear();
        let args = [{
          years: [year],
          scopes: [1, 2, 3],
          corporations: [this.corporation.code],
          groupKeys: ['year', 'scope', 'corporation_code']
        }];

        let data = new FormData()
        data.append('path', 'esg/ghg_emission/main');
        data.append('json', JSON.stringify(args));

        this.abortController = new AbortController();
        let response = await axios.post('esg/lca/run/python/chart-data', data, {
          headers: { Authorization: accessToken() },
          signal: this.abortController.signal
        });

        // If there is no data, return
        if (!response.data.data) {
          this.series = [];
          return;
        }


        let list = JSON.parse(response.data.data)[0].data

        this.series = list.map(row => row.values);
        this.chartOptions.labels = list.map(obj => `Scope ${obj.scope}`);
      } catch (error) {
        this.loading = false;
        await this.showError(error);
      } finally {
        this.loading = false;
        this.refreshChart();
      }
    },
  },
}
</script>
